import { Loading, DotsLoader, LoadingModal } from 'app/common/templates-next/page-template'

export default Loading

export { DotsLoader, LoadingModal }
